var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer-header"},[(_vm.channel.useTextHeader)?_c('HeaderText',{attrs:{"channel":_vm.channel}}):_c('HeaderImage',{attrs:{"headerImgUrl":_vm.channel.headerImgUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }